
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.562 18.993a16.004 16.004 0 01-9.354-2.99v13.616a12.385 12.385 0 11-10.684-12.272v6.85a5.685 5.685 0 103.98 5.422V3h6.704a9.233 9.233 0 00.142 1.69 9.309 9.309 0 004.107 6.111 9.252 9.252 0 005.105 1.535v6.657z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    